import { FormikErrors } from 'formik';

export const extractErrorPaths = <T>(errors: FormikErrors<T>, path = ''): string[] => {
  let result: string[] = [];

  for (const key in errors) {
    const newPath = path ? `${path}.${key}` : key;
    const error = errors[key];

    if (typeof error === 'object' && error !== null && !Array.isArray(error)) {
      result = result.concat(extractErrorPaths(error as FormikErrors<any>, newPath));
    } else if (Array.isArray(error)) {
      error?.forEach((item, index) => {
        const arrayPath = `${newPath}[${index}]`;
        if (typeof item === 'object' && item !== null) {
          result = result.concat(extractErrorPaths(item as FormikErrors<any>, arrayPath));
        } else if (item) {
          result.push(arrayPath);
        }
      });
    } else if (error) {
      result.push(newPath);
    }
  }

  return result;
};

export const sanitizeElementId = (string: string, substitution = '_') =>
  string
    ?.replace(/[^A-Za-z0-9_-]|\.|,/g, substitution) // Ersätt ogiltiga tecken
    .replace(/_+/g, substitution); // Rensa dubbla ersättningstecken

export const setApiValidationErrors = (error: any, setFieldError: (field: string, message?: string) => void) => {
  if ('error_fields' in error) {
    const errorMessagesMap: Record<string, string[]> = {};
    Object.values(error.error_fields)
      .flat()
      .forEach((err: any) => {
        if (!errorMessagesMap[err.field]) {
          errorMessagesMap[err.field] = [];
        }
        errorMessagesMap[err.field].push(err.message);
      });

    Object.entries(errorMessagesMap).forEach(([field, messages]) => {
      setFieldError(field, messages.join('\n\n'));
    });
  }
};
